import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Ajax from '../../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from '../list-mutations';
import SecondHand from '../../entities/booking/secondHand';
import SecondHandImage from '../../entities/booking/secondHandImage'

interface SecondHandState extends ListState<SecondHand>{
    editSecondHand:SecondHand
}
class SecondHandMutations extends ListMutations<SecondHand>{

}
class SecondHandModule extends ListModule<SecondHandState,any,SecondHand>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<SecondHand>(),
        loading:false,
        editSecondHand:new SecondHand()
    }
    actions={
        async getAll(context:ActionContext<SecondHandState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/SecondHand/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<SecondHand>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<SecondHandState,any>,payload:any){
            await Ajax.post('/api/services/app/SecondHand/Create',payload.data);
        },
        async createWithImages(context:ActionContext<SecondHandState,any>,payload:any){
            await Ajax.post('/api/services/app/SecondHand/CreateWithImages',payload.data);
        },
        async update(context:ActionContext<SecondHandState,any>,payload:any){
            await Ajax.put('/api/services/app/SecondHand/Update',payload.data);
        },
        async updateWithImages(context:ActionContext<SecondHandState,any>,payload:any){
            await Ajax.put('/api/services/app/SecondHand/UpdateWithImages',payload.data);
        },
        async delete(context:ActionContext<SecondHandState,any>,payload:any){
            context.state.loading=true;
            await Ajax.delete('/api/services/app/SecondHand/Delete?Id='+payload.data.id);
            context.state.loading=false;
        },
        async get(context:ActionContext<SecondHandState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/SecondHand/Get?Id='+payload.id);
            return reponse.data.result as SecondHand;
        }
    };
    mutations={
        setCurrentPage(state:SecondHandState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:SecondHandState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:SecondHandState,secondHand:SecondHand){
            state.editSecondHand=secondHand;
        },
        changeLoading(state:SecondHandState,pass:boolean){
            state.loading = pass;
        }
    }
}
const secondHandModule=new SecondHandModule();
export default secondHandModule;